export default __webpack_public_path__ + "static/media/gas-poly.bd636812.svg";